import React, { memo } from 'react';
import { Modal } from '../forms/AdminForm';
import ProductForm from '../forms/product/ProductForm';
import { Product } from '../../types/product';
import { OptionType } from '../../types/optionTypes';

interface ProductModalsProps {
  // Add Modal
  showAdd: boolean;
  onCloseAdd: () => void;
  onAdd: () => void;
  newProduct: Partial<Product>;
  onUpdateNewProduct: (updates: Partial<Product>) => void;

  // Edit Modal
  isEditing: boolean;
  onCloseEdit: () => void;
  onEditSave: () => void;
  editProduct: Partial<Product> | null;
  onUpdateEditProduct: (updates: Partial<Product>) => void;

  // Categories
  mainCategories: any[];
  filteredSubCategories: any[];
  selectedMainCategory: string;
  onMainCategoryChange: (categoryId: string) => void;

  // Option Types
  optionTypes: OptionType[];
}

export const ProductModals = memo<ProductModalsProps>(
  ({
    // Add Modal
    showAdd,
    onCloseAdd,
    onAdd,
    newProduct,
    onUpdateNewProduct,

    // Edit Modal
    isEditing,
    onCloseEdit,
    onEditSave,
    editProduct,
    onUpdateEditProduct,

    // Categories
    mainCategories,
    filteredSubCategories,
    selectedMainCategory,
    onMainCategoryChange,

    // Option Types
    optionTypes,
  }) => {
    return (
      <>
        {/* Add Product Modal */}
        <Modal
          isOpen={showAdd}
          onClose={onCloseAdd}
          title="Yeni Ürün Ekle"
          onSave={onAdd}
          saveText="Ürünü Ekle"
          size="lg"
        >
          <ProductForm
            product={newProduct}
            onUpdate={onUpdateNewProduct}
            mainCategories={mainCategories}
            filteredSubCategories={filteredSubCategories}
            selectedMainCategory={selectedMainCategory}
            onMainCategoryChange={onMainCategoryChange}
            optionTypes={optionTypes}
          />
        </Modal>

        {/* Edit Product Modal */}
        <Modal
          isOpen={isEditing}
          onClose={onCloseEdit}
          title="Ürünü Düzenle"
          onSave={onEditSave}
          saveText="Değişiklikleri Kaydet"
          size="lg"
        >
          {editProduct && (
            <ProductForm
              product={editProduct}
              onUpdate={onUpdateEditProduct}
              mainCategories={mainCategories}
              filteredSubCategories={filteredSubCategories}
              selectedMainCategory={selectedMainCategory}
              onMainCategoryChange={onMainCategoryChange}
              optionTypes={optionTypes}
              isEdit
            />
          )}
        </Modal>
      </>
    );
  }
);

ProductModals.displayName = 'ProductModals';
